import type { JSX } from 'react'

export const BundleCover5 = (): JSX.Element => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 1920 1080'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='none'
  >
    <g clipPath='url(#clip0_628_264)'>
      <rect width='1920' height='1080' fill='#161616' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1433.74 1080H1229C1221.47 1071.92 1213.51 1063.2 1205.19 1053.94C1167.32 1011.81 1119.55 955.787 1065.49 890.992C975.106 782.656 865.515 647.861 752.543 508.906C730.31 481.559 707.945 454.051 685.571 426.553C562.404 275.18 438.875 124.012 334.015 0H542.726C627.169 101.615 718.812 213.895 809.68 325.572C832.171 353.215 854.614 380.818 876.894 408.223C989.886 547.201 1098.68 681.012 1188.35 788.492C1201.72 804.52 1214.63 819.918 1227.04 834.623C1207.52 762.65 1183.15 678.918 1155.68 588.266C1099.71 403.59 1031.68 192.949 967.594 0H1136.15C1195.56 179.842 1257.2 371.598 1308.8 541.859C1354.84 693.77 1393.46 830.42 1415.26 926.572C1425.87 973.398 1433.72 1015.75 1435.15 1046.47C1435.53 1054.57 1435.57 1063.71 1434.63 1072.99C1434.43 1074.99 1434.15 1077.36 1433.74 1080ZM274.419 0C313.839 119.312 362.929 258.352 414.252 400.6C451.014 502.486 489.489 607.562 526.044 707.396L526.105 707.566C562.473 806.885 596.938 901.01 625.924 981.639C638.491 1016.6 650.23 1049.57 660.891 1080H491.189C486.104 1065.72 480.821 1050.97 475.357 1035.77C445.744 953.393 411.909 861.008 376.083 763.188C339.903 664.4 301.693 560.068 263.749 454.9C205.336 293.002 148.879 132.719 106.111 0H274.419ZM182.479 1080H0V844.871C62.7729 943.875 124.317 1020.7 182.479 1080Z'
        fill='url(#paint0_linear_628_264)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1712.38 0H1430.7C1245.45 139.92 1052.25 316.604 876.056 491.795C656.913 709.688 460.535 928.846 333.285 1080H544.135C663.429 943.436 819.218 773.939 988.869 605.256C1227.12 368.361 1488.46 137.369 1712.38 0ZM1920 493.975C1838.82 552.754 1751.88 615.119 1666.37 675.574C1526.12 774.73 1388.38 869.701 1285.28 935.861C1234.16 968.66 1189.46 995.74 1156.55 1012.67C1141.28 1020.52 1123.12 1029.08 1106.14 1033.5C1099.86 1035.14 1080.35 1040.11 1057.88 1034.55C1044.53 1031.26 1026.35 1023.25 1012.08 1005.24C997.708 987.113 994 967.307 994 953C994 934.273 1000.09 919.244 1002.75 913.01C1006.25 904.84 1010.5 897.141 1014.47 890.543C1022.47 877.234 1033.05 862.242 1044.81 846.639C1068.57 815.113 1101.71 775.145 1140.55 730.252C1218.49 640.156 1322.98 526.145 1430.21 412.078C1575.03 258.039 1728.36 100.176 1829.58 0H1920V135.676C1823.64 231.895 1683.57 376.178 1546.79 521.672C1508.16 562.754 1470.05 603.672 1433.54 643.32C1479.02 611.797 1526.25 578.688 1574 544.926C1693.58 460.389 1815.43 372.479 1920 296.168V493.975Z'
        fill='url(#paint1_linear_628_264)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_628_264'
        x1='725.184'
        y1='-126.427'
        x2='725.184'
        y2='1183.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#212B53' />
        <stop offset='1' stopColor='#171617' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_628_264'
        x1='1116.94'
        y1='-74.1718'
        x2='1116.94'
        y2='1172.26'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#232C51' />
        <stop offset='1' stopColor='#262526' />
      </linearGradient>
      <clipPath id='clip0_628_264'>
        <rect width='1920' height='1080' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
